<!-- player -->
<template>
  <div class="music-bar" :id="idName" ref="musicBar">
      <audio :src="currentMusic" ref="audio" @ended="end"></audio>
      <div class="avatar">
        <img src="../assets/1.png" alt="">
      </div>
      <div class="song-detail" v-show="visible">
        <div>{{title}}</div>
        <div>{{songer}}</div>
      </div>
      <div class="player" v-show="visible">
        <div class="pre" @click="pre">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m16 7-7 5 7 5zm-7 5V7H7v10h2z"></path></svg>
        </div>
        <div class="play" @click="play" v-if="status === '1'">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 6v12l10-6z"></path></svg>
        </div>
        <div class="stop" @click="stop" v-if="status === '2'">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8 7h3v10H8zm5 0h3v10h-3z"></path></svg>
        </div>
        <div class="next" @click="next">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 7v10l7-5zm9 10V7h-2v10z"></path></svg>
        </div>
      </div>
      <div class="btn" @click="togger">{{symbols}}</div>
    </div>
</template>

<script>
export default {
  props: {
    musicList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentMusic: '', // 当前音乐
      status: '1', // 播放状态
      songer: '', // 歌手
      title: '', //  歌名
      songIndex: 0, // 音乐索引
      symbols: '-',
      idName: 'long',
      visible: true,

    }
  },
  mounted () {
    this.changeMusic()
  },
  methods: {
    changeMusic () {
      this.currentMusic = this.musicList[this.songIndex].song
      this.songer = this.musicList[this.songIndex].songer
      this.title = this.musicList[this.songIndex].title
    },
    // 伸长缩短
    togger () {
      this.idName === 'long' ? this.idName = 'short' : this.idName = 'long'
      this.symbols === '-' ? this.symbols = '+' : this.symbols = '-'
      this.visible = !this.visible
    },
    // 播放
    play () {
      this.$nextTick(() => {
        this.status = '2'
        this.$refs.audio.play()
      })
    },
    // 停止
    stop () {
      this.$nextTick(() => {
        this.status = '1'
        this.$refs.audio.pause()
      })
    },
    // 上一曲
    pre () {
      if (this.songIndex === 0) {
        this.songIndex = this.musicList.length - 1
      } else {
        this.songIndex--
      }
      this.changeMusic()
    },
    // 下一曲
    next () {
      if (this.songIndex === this.musicList.length - 1) {
        this.songIndex = 0
      } else {
        this.songIndex ++
      }
      this.changeMusic()
    },
    // 音乐结束
    end () {
      this.next()
    }
  },
  watch: {
    currentMusic (newMusic) {
      if (this.status === '1') return
      this.play()
    }
  }
}

</script>
<style lang='scss' rel='stylesheet/scss' scoped>
#short {
  width:140px;
}
#long{
  width: 374px;
}
#show {
  opacity: 1;
  z-index: 999;
}
#hide {
  opacity: 0;
  z-index:  -1;
}
.music-bar{
  position:fixed;
  left:0;
  bottom:50px;
  height:56px;
  background-color: #fff;
  transition: all .2s;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  .avatar{
    img{
      width: 50px;
      border-radius: 50%;
      transform: translateX(10px);
    }
  }
  .song-detail{
    transition: all .2s;
    height:100%;
    width:180px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    div:nth-child(1) {
      font-size: 20px;
      color:black;
      margin-bottom: 5px;
      font-weight: bolder;
      white-space: nowrap;
    }
    div:nth-child(2){
      font-size: 12px;
      color:gray;
      white-space: nowrap;
    }
  }
  .player{
    transition: all .2s;
    display: flex;
    justify-content: space-between;
    align-items: center;
    div{
      width: 40px;
      height:40px;
      cursor: pointer;
    }
  }
  .btn{
    width:60px;
    height:60px;
    background-color: #C62F42;
    display:flex;
    justify-content: center;
    align-items: center;
    font-size: 38px;
    color: white;
    font-weight: bolder;
    cursor: pointer;
  }
}
</style>